export async function loadLayoutMiddleware(route) {
  const { layout } = route.meta;
  const normalizedLayoutName = layout || 'DefaultLayout';
  const fileName = normalizedLayoutName;
  const fileNameWithoutExtension = fileName.split('.vue')[0];

  try {
    const component = await import(`../../layouts/${fileNameWithoutExtension}.vue`);
    // Проверяем, что компонент загрузился корректно
    if (component && component.default) {
      route.meta.layoutComponent = component.default;
    } else {
      console.warn(`Layout component ${normalizedLayoutName} loaded but has no default export`);
      // Fallback на DefaultLayout
      const defaultComponent = await import(`../../layouts/DefaultLayout.vue`);
      route.meta.layoutComponent = defaultComponent.default;
    }
  } catch (error) {
    console.error(`Failed to load layout component ${normalizedLayoutName}:`, error);
    // Fallback на DefaultLayout
    try {
      const defaultComponent = await import(`../../layouts/DefaultLayout.vue`);
      route.meta.layoutComponent = defaultComponent.default;
    } catch (fallbackError) {
      console.error('Failed to load DefaultLayout as fallback:', fallbackError);
      // Устанавливаем простой компонент как последний fallback
      route.meta.layoutComponent = { template: '<div><slot /></div>' };
    }
  }
}
